/**
 * Created by Ning Jiang on 2024-10-22.
 */
import {TimelineLite} from "gsap";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ElGordosRevengeLayers, Layers} from "./ElGordosRevengeLayers";
import {ElGordosRevengeReelView} from "../reels/ElGordosRevengeReelView";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class NearWinView {

    private _layer:StageLayer;

    private _currentBigWinNearWinReelId:number = -1;
    private _currentScatterNearWinReelId:number = -1;
    private _currentAnimation:PIXI.spine.Spine | null;
    private _startTl:TimelineLite | null;
    private _bgStartTl:TimelineLite | null;
    private _currentAnticipationSoundId:number = -1;

    constructor() {
        this._layer = ElGordosRevengeLayers.getLayer(Layers.NEAR_WIN)!;
    }

    public isScatterNearWinPlaying():boolean {
        return this._currentScatterNearWinReelId > -1;
    }

    public isBigWinNearWinPlaying():boolean {
        return this._currentBigWinNearWinReelId > -1;
    }

    public stopScatterNearWin(reelId:number):void {
        if(this._currentScatterNearWinReelId === -1) {
            return;
        }
        Logger.logDev(`SOUND---------------------------stopScatterNearWon on reel ${reelId}`);
        this.stopCurrentAnimation();
        ElGordosRevengeSound.soundPlayer.stopTrack(ElGordosRevengeSound.SCATTER_ANTICIPATION_BASE);
        ElGordosRevengeSound.soundPlayer.stopTrack(ElGordosRevengeSound.SCATTER_ANTICIPATIONS[this._currentAnticipationSoundId]);
        this._currentAnticipationSoundId = -1;
        if(ElGordosRevenge.model.parsedGameData.nextMode.includes(GameMode.FREESPIN)) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_ANTICIPATION_SUCCESS});
        } else {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_ANTICIPATION_FAIL});
        }
    }

    public playScatterNearWin(reelId:number, scatterLength:number):void {
        Logger.logDev(`SOUND---------------------------playScatterNearWin on reel ${reelId}`);
        if(this._currentAnimation && reelId != this._currentScatterNearWinReelId) {
            this.stopCurrentAnimation();
        }
        const animation = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("anticipation"));
        animation.autoUpdate = true;
        const reelRect = ElGordosRevengeReelView.REEL_AREAS[reelId];
        animation.position.set(reelRect.x, 360);
        const size = reelId === 5 ? "2" : "3"
        const startTl = new TimelineLite();
        startTl.add(() => {
            this._layer.addChild(animation);
            animation.state.setAnimation(0, `start_1x${size}`, false);
            if(scatterLength === 2 && this._currentAnticipationSoundId != 2) {
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_ANTICIPATION_BASE});
            }
            if(this._currentAnticipationSoundId != scatterLength) {
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_ANTICIPATIONS[scatterLength]});
                this._currentAnticipationSoundId = scatterLength;
            }
        });
        startTl.add(() => {
            if(animation.state) {
                animation.state.setAnimation(0, `loop_1x${size}`, true);
            }
            this._startTl = null;
        }, `+=${animation.spineData.findAnimation(`start_1x${size}`).duration}`);
        this._currentAnimation = animation;
        this._startTl = startTl;
        this._currentScatterNearWinReelId = reelId;
    }

    private stopCurrentAnimation():void {
        if(this._startTl && this._startTl.isActive()) {
            this._startTl.progress(1);
        }
        this._startTl = null;
        if(this._currentAnimation) {
            const endTimeline = new TimelineLite();
            const endAnimation = this._currentAnimation;
            const aniName = `end_1x${this._currentScatterNearWinReelId === 5 ? "2" : "3"}`;
            this._currentAnimation = null;
            endTimeline.add(() => {
                endAnimation.state.setAnimation(0, aniName, false);
            });
            endTimeline.add(() => {
                endAnimation.state.setEmptyAnimations(0);
                endAnimation.parent.removeChild(endAnimation);
                endAnimation.destroy();
            }, `+=${endAnimation.spineData.findAnimation(aniName).duration}`);
        }
        this._currentScatterNearWinReelId = -1;
    }

    public playAnticipationNoScatterLand(reelId:number):void {
        ElGordosRevengeSound.playRandomAnticipationLandSound(reelId);
    }

    public playBigWinNearWin(reelId:number):void {
        const startTl = new TimelineLite();
        startTl.add(() => {ElGordosRevenge.background.playBoostAnimation(true)});
        startTl.add(() => {
            this._bgStartTl = null;
        });
        this._bgStartTl = startTl;

        if(this._currentBigWinNearWinReelId < 0) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BIG_WIN_ANTICIPATION});
        }
        this._currentBigWinNearWinReelId = reelId;
    }

    public stopBigWinNearWin(reelId?:number):void {
        if(this._currentBigWinNearWinReelId < 0) {
            return;
        }
        ElGordosRevengeSound.soundPlayer.stopTrack(ElGordosRevengeSound.BIG_WIN_ANTICIPATION);
        if(reelId === 5) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.BIG_WIN_ANTICIPATION_SUCCESS});
        }
        this._currentBigWinNearWinReelId = -1;
    }
}